export default function TermsOfService() {
  return (
    <section className="page-shell legal-page">
      <div className="container">
        <div className="page-shell__content">
          <p className="page-eyebrow">Legal</p>
          <h1>Terms of Service</h1>
          <p className="page-lead">
            These Terms of Service describe the basic conditions for using GEO_AI Systems website features and file submission tools.
          </p>

          <h2>Use of the Service</h2>
          <p>
            You may use the website to submit well log digitization requests, review service information, and contact support. You are responsible for the accuracy and legality of the information and files you submit.
          </p>

          <h2>Uploaded Materials</h2>
          <p>
            By uploading files, you confirm that you have permission to provide them for analysis, conversion, and related technical processing.
          </p>

          <h2>Digitization Results</h2>
          <p>
            AI-assisted digitization can improve speed and consistency, but outputs should be reviewed before being used for technical, operational, commercial, or regulatory decisions.
          </p>

          <h2>Acceptable Use</h2>
          <p>
            Do not submit unlawful, malicious, confidential, or unauthorized materials. Do not attempt to disrupt, reverse engineer, overload, or misuse the service.
          </p>

          <h2>Changes</h2>
          <p>
            We may update these terms as the website and service evolve. Continued use of the website means you accept the current version.
          </p>
        </div>
      </div>
    </section>
  );
}
